'use client'

import { FC } from 'react'

import { useMediaScreen } from '@/lib/use-media-screen'
import { ROUTES } from '@/constants/routes'
import { Button } from '@/uikit/button'
import { Container } from '@/uikit/container'
import { useCookies } from './use-cookies.hook'

import styles from './cookies.module.scss'

export interface CookiesPopupProps {}

export const CookiesPopup: FC<CookiesPopupProps> = () => {
  const { cookiesAccepted, acceptCookies } = useCookies()
  const isSmallScreen = useMediaScreen() === 'small'

  const handleClick = () => {
    acceptCookies()
  }

  if (cookiesAccepted) return null

  return (
    <section className={styles.cookies}>
      <Container variant={isSmallScreen ? 'full' : 'wide'}>
        <div className={styles.container}>
          <span className={styles.text}>
            Мы используем файлы cookie, чтобы вам было удобно работать с сайтом. Нажимая кнопку
            «Принимаю», Вы подтверждаете, что ознакомлены с{' '}
            <Button
              target="_blank"
              className={styles.link}
              variant="green-link"
              href={`/${ROUTES.COOKIES_DOCUMENT}`}
            >
              Соглашением об использовании cookie
            </Button>{' '}
            и даете согласие на их использование.
          </span>
          <Button variant="black" onClick={handleClick}>
            Принимаю
          </Button>
        </div>
      </Container>
    </section>
  )
}
